import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';

interface ConfirmBookingModalProps {
  show: boolean;
  title?: string;
  message?: string;
  itemTitle?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  icon?: IconProp;
  confirmVariant?: 'phoenix-primary' | 'phoenix-danger' | 'secondary';
  showConfirmButton?: boolean;
}

const ConfirmBookingModal = ({
  show,
  title = 'Confirm Booking',
  message = 'Are you sure you want to book',
  itemTitle = 'this shift?',
  onConfirm,
  onCancel,
  isLoading = false,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  icon = faCalendar,
  confirmVariant = 'phoenix-primary',
  showConfirmButton = true
}: ConfirmBookingModalProps) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Body className="p-4">
        <div className="text-center mb-3">
          <div className="mb-3">
            <FontAwesomeIcon
              icon={icon}
              className={`fs-3 ${confirmVariant === 'phoenix-danger' ? 'text-danger' : 'text-primary'}`}
            />
          </div>
          <h5 className="fw-semibold mb-2">{title}</h5>
          {message && message.includes('<') ? (
            <p 
              className="text-body-tertiary mb-0"
              dangerouslySetInnerHTML={{ __html: message }}
            />
          ) : (
            <p className="text-body-tertiary mb-0">
              {message} <strong>{itemTitle}</strong>
            </p>
          )}
        </div>

        <div className={`d-flex ${showConfirmButton ? 'gap-2' : 'justify-content-center'} justify-content-center pt-3`}>
          <Button
            variant="secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelLabel}
          </Button>
          {showConfirmButton && (
            <Button
              variant={confirmVariant}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? `${confirmLabel}...` : confirmLabel}
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmBookingModal;
